import { Check } from 'lucide-react';
import { cn } from '@payment-plan/ui';

export const FLOW_STEPS = ['Unidad', 'Separantes', 'Condiciones', 'Cuotas'] as const;

/** Stepper del flujo del asesor (lenguaje «Atelier», web 04). El paso actual lleva `aria-current`. */
export function FlowSteps({ current }: { current: number }): React.JSX.Element {
  return (
    <ol aria-label="Pasos de la separación" className="flex flex-wrap items-center gap-x-3 gap-y-2 text-sm">
      {FLOW_STEPS.map((label, index) => {
        const numero = index + 1;
        const hecho = numero < current;
        const actual = numero === current;
        return (
          <li
            key={label}
            aria-current={actual ? 'step' : undefined}
            className="flex items-center gap-2"
          >
            <span
              aria-hidden="true"
              className={cn(
                'flex h-8 w-8 items-center justify-center rounded-full border text-xs font-semibold transition-colors',
                hecho || actual
                  ? 'border-brand-gold bg-gold-sheen text-brand-gold-dark'
                  : 'border-border text-muted-foreground',
                actual && 'shadow-inset-gold',
              )}
            >
              {hecho ? <Check className="h-4 w-4" /> : numero}
            </span>
            <span className={cn(hecho || actual ? 'font-medium text-foreground' : 'text-muted-foreground')}>
              {label}
            </span>
            {hecho && <span className="sr-only">(completado)</span>}
            {index < FLOW_STEPS.length - 1 && <span aria-hidden="true" className="hidden h-px w-8 bg-border sm:block" />}
          </li>
        );
      })}
    </ol>
  );
}
